import { ComponentType } from "@angular/cdk/portal";
import { Injectable, TemplateRef } from "@angular/core";
import { MatDialog, MatDialogConfig, MatDialogRef } from "@angular/material/dialog";

@Injectable({
  providedIn: 'root'
})
export class SabisNgxDialogService {

  constructor(private _dialog: MatDialog) { }

  /**
 * Opens a modal dialog containing the given component.
 * @param component Type of the component to load into the dialog.
 * @param config Extra configuration options.
 * @returns Reference to the newly-opened dialog.
 */
  public open<T, D = any, R = any>(component: ComponentType<T>, config?: SabisDialogConfig<D>): SabisDialogRef<T, R>;
  /**
   * Opens a modal dialog containing the given template.
   * @param template TemplateRef to instantiate as the dialog content.
   * @param config Extra configuration options.
   * @returns Reference to the newly-opened dialog.
   */
  public open<T, D = any, R = any>(template: TemplateRef<T>, config?: SabisDialogConfig<D>): SabisDialogRef<T, R>;
  public open<T, D = any, R = any>(template: ComponentType<T> | TemplateRef<T>, config?: SabisDialogConfig<D>): SabisDialogRef<T, R> {
    return this._dialog.open(template, config);
  }
}

export class SabisDialogConfig<D> extends MatDialogConfig<D> {

}

export class SabisDialogRef<T, R> extends MatDialogRef<T, R>{

}
